if settings.include_images
    each decl in declarations
        if decl.type == 'bitmap'
            | static const unsigned char !{decl.data.name}[]!{settings.progmem? ' U8X8_PROGMEM': ''} = {!{decl.data.value}};
            |
if settings.declare_vars
    each decl in declarations
        if decl.type == 'var'
            if decl.data.type === 0
                | const char* !{decl.data.name} = "!{decl.data.value}";
            else
                | int !{decl.data.name} = !{decl.data.value};
            |
            |
each layer in layers
    if layer.type == 'polygon'
        - var pts = layer.points
        |
        | void !{layer.functionName}(void) {
        |
        - for (var pi = 0; pi < pts.length; pi++)
            - var npi = (pi + 1) % pts.length
            |     !{displayObject}.drawLine(!{pts[pi][0]}, !{pts[pi][1]}, !{pts[npi][0]}, !{pts[npi][1]});
            |
        | }
        |
|
|
- var pad = settings.wrap ? '    ' : ''
if settings.wrap
    | void draw!{screenTitle}(void) {
    |
if settings.clear_screen
    | !{pad}!{displayObject}.clearBuffer();
    |
| !{pad}!{displayObject}.setFontMode(1);
| !{pad}!{displayObject}.setBitmapMode(1);
|
- var font = ''
- var drawColorMode = -1;
each layer in layers 
    if settings.comments
        | !{pad}// !{layer.name}
        |
    if layer.inverted 
        if drawColorMode != 2
            | !{pad}!{displayObject}.setDrawColor(2);
            |
            - drawColorMode = 2;
    else
        if drawColorMode != layer.color
            | !{pad}!{displayObject}.setDrawColor(!{layer.color});
            |
            - drawColorMode = layer.color;
    case layer.type
        when 'line'
            | @!{layer.uid};!{pad}!{displayObject}.drawLine(@x1:!{layer.x1}, @y1:!{layer.y1}, @x2:!{layer.x2}, @y2:!{layer.y2});
        when 'rect'
            - var func = 'draw' + (layer.radius? 'R': '') + (layer.fill ? 'Box' : 'Frame')
            | @!{layer.uid};!{pad}!{displayObject}.!{func}(@x:!{layer.x}, @y:!{layer.y}, @w:!{layer.w}, @h:!{layer.h}!{layer.radius? `, @r:${layer.radius}`: ''});
        when 'circle'
            - var func = layer.fill ? 'drawDisc' : 'drawCircle'
            | @!{layer.uid};!{pad}!{displayObject}.!{func}(@x:!{layer.x}, @y:!{layer.y}, @r:!{layer.radius});
        when 'ellipse'
            - var func = layer.fill ? 'drawFilledEllipse' : 'drawEllipse'
            | @!{layer.uid};!{pad}!{displayObject}.!{func}(@x:!{layer.x}, @y:!{layer.y}, @rx:!{layer.rx}, @ry:!{layer.ry});
        when 'triangle'
            | @!{layer.uid};!{pad}!{displayObject}.drawTriangle(@x1:!{layer.x1}, @y1:!{layer.y1}, @x2:!{layer.x2}, @y2:!{layer.y2}, @x3:!{layer.x3}, @y3:!{layer.y3});
        when 'string'
            if layer.font != font
                - font = layer.font
                | !{pad}!{displayObject}.setFont(u8g2_font_!{layer.font}_tr);
                |
            - let is_ascii = (s) => /^[\x00-\x7F]*$/.test(s)
            - var textContent = layer.isTextVariable ? layer.text : `"${layer.text}"`;
            if is_ascii(layer.text)
                | @!{layer.uid};!{pad}!{displayObject}.drawStr(@x:!{layer.x}, @y:!{layer.y}, @text:!{textContent});
            else
                | @!{layer.uid};!{pad}!{displayObject}.drawUTF8(@x:!{layer.x}, @y:!{layer.y}, @text:!{textContent});
        when 'paint'
        when 'icon'
            - var func = settings.progmem ? 'drawXBMP' : 'drawXBM'
            | @!{layer.uid};!{pad}!{displayObject}.!{func}(!{layer.x}, !{layer.y}, !{layer.w}, !{layer.h}, !{layer.imageName});
        when 'polygon'
            | @!{layer.uid};!{pad}!{layer.functionName}();
        default 
            |
            | // Unknown layer type !{layer.type}
            |
    |
    |
    |
| !{pad}!{displayObject}.sendBuffer();
|
if settings.wrap
    | }
    |
